import React, { useState, useCallback, useEffect } from 'react';
import { Grid, TextField, InputAdornment, Hidden } from '@mui/material';
import { DateRangePicker, IDateRange } from 'components/daterange';
import { SearchOutlined } from '@mui/icons-material';
import requests from 'api/requests';
import { format } from 'date-fns';
import InvoicesTable from './table';
import { IInvoice } from './types';
import Invoice from './invoice';
import InvoicesTablePagination from './pagination';
import { PaginationGridBox, TablePaperBox } from 'components/styled';


export default function Invoices() {
  const [searchString, setSearchString] = useState('');
  const [invoice, setInvoice] = useState<IInvoice|null>(null);
  const [dateRange, setDateRange] = useState<IDateRange>({
    startDate: undefined,
    endDate: undefined,
  });
  const [page, setPage] = useState({
    first_loaded: false,
    items: [],
    items_count: 0,
    page: 0,
    limit: 30,
  })

  const filters = useCallback(() => {
    let new_filter:any = {
    };
    if(dateRange.startDate){
      new_filter.date__gte = format(dateRange.startDate as Date, "yyyy-MM-dd");
    }
    if(dateRange.endDate){
      new_filter.date__lte = format(dateRange.endDate as Date, "yyyy-MM-dd");
    }
    if(searchString){
      new_filter.search = searchString;
    }
    return new_filter;
  }, [dateRange, searchString])

  const load = useCallback(() => {
    window.scrollTo(0, 0);
    
    requests.get('/corp/invoice/', {
      ...filters(),
      limit: page.limit,
      offset: page.page * page.limit
    }).then((r) => {
      setPage(page => ({
        ...page,
        first_loaded: true,
        items: r.body.results,
        items_count: r.body.count
      }));
    })
  }, [page.page, page.limit, filters])
  useEffect(() => load(), [load]);

  return (
    <div>
      { page.first_loaded && (
        <div>
          <Grid container>
            <Grid item xs={12} md={8}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={5} lg={4} xl={3}>
                  <DateRangePicker
                    dateRange={dateRange}
                    onChange={(range) => setDateRange(range)}
                  />
                </Grid>
                <Grid item xs={12} sm={5} lg={4} xl={3}>
                  <TextField
                    fullWidth
                    placeholder="Пошук"
                    value={ searchString }
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      setSearchString(e.target.value);
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchOutlined color={'action'} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Hidden mdDown>
              <PaginationGridBox item sm={4}>
                <InvoicesTablePagination
                  count={page.items_count}
                  limit={page.limit}
                  page={page.page}
                  onChange={(page_number:number) => {
                    setPage({
                      ...page,
                      page: page_number
                    });
                  }}
                />
              </PaginationGridBox>
            </Hidden>
          </Grid>
          <TablePaperBox>
            <InvoicesTable
              items={page.items}
              onClick={(item:IInvoice) => {
                setInvoice(item);
              }}
              showCompanyColumn
            />
          </TablePaperBox>
          <InvoicesTablePagination
            count={page.items_count}
            limit={page.limit}
            page={page.page}
            onChange={(page_number:number) => {
              setPage({
                ...page,
                page: page_number
              });
            }}
          />
        </div>
      )}

      { invoice && (
        <Invoice
          invoice={invoice}
          stamp={false}
          onClose={() => {
            setInvoice(null);
          }}
        />
      )}
    </div>
  );
}